import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';
import Overlay from '../Miscelania/Overlay';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import getLocale from '../../i18n/getLocale';

class EmailFatigueQuestions extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      message: '',
      fatigue_system_efficient: false,
      fadigado: false,
      status: 0,
    };
    // Handlers
    this.edit = this.edit.bind(this);
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/questionario/pesquisa/fadiga/'+self.props.match.params.token;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({
            status: 1,
          });
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      token: this.props.match.params.token,
      contramedidas: this.state.contramedidas,
      fatores_fadiga: this.state.fatores_fadiga,
      fadigado: this.state.fadigado,
      ultimo_dia_acordou: this.state.ultimo_dia_acordou,
      ultimo_dia_dormiu: this.state.ultimo_dia_dormiu,
      penultimo_dia_acordou: this.state.penultimo_dia_acordou,
      penultimo_dia_dormiu: this.state.penultimo_dia_dormiu,
      qualidade_sono_ultimo: this.state.qualidade_sono_ultimo,
      qualidade_sono_penultimo: this.state.qualidade_sono_penultimo,
      tres_dias_horas_dormiu: this.state.tres_dias_horas_dormiu,
      tres_dias_horas_acordou: this.state.tres_dias_horas_acordou,
      qualidade_sono_tres_dias: this.state.qualidade_sono_tres_dias,
      details: this.state.details,
      sinais: this.state.sinais,
      fatigue_system_efficient: this.state.fatigue_system_efficient,
      sugestoes: this.state.sugestoes,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questionario/pesquisa/fadiga/reposta', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  render() {
    return (
<div className="user-wrapper">
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="user-layer-suspended">
    <div className="container-liquid">
      <div className="conteudo">
        <h3 className="page-title">{this.locale.Usuarios.Questionario.titulo}</h3>
        <hr/>
        {this.state.status == 0 ?
          ""
          :
          <form onSubmit={this.edit}>
            <div className="row">
              <div className="col-md-4 col-md-offset-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.VoceConcordaQueSeSentiuFadigadoNosUltimosDias}?</label>
                  <br/>
                  <Toggle
                    checked={this.state.fadigado}
                    aria-label='No label tag'
                    name="fadigado"
                    onChange={this.handleToggleChange.bind(this, 'fadigado')} />
                </div>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-4 col-md-offset-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.SelecioneOsFatoresQueContribuiramParaAFadiga}</label>
                  <Select
                    className="form-field-name"
                    name="fatores_fadiga"
                    value={this.state.fatores_fadiga}
                    searchable={true}
                    placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarUmaOpcao}
                    onChange={this.handleSelectChangeMulti.bind(this, 'fatores_fadiga')}
                    multi={true}
                    options={[
                      {value: 'nao_fadigado', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.NaoMeSentiFadigado},
                      {value: 'hotel_casa', label: 'Hotel/Casa'},
                      {value: 'descanso_insuficiente', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.DescansoInsuficienteEntreJornadas},
                      {value: 'jornada_interrompida', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.JornadaInterrompida},
                      {value: 'transicao_jornada_diurno', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.TransicaoDaJornadaDiurnoParaNoturno},
                      {value: 'transicao_jornada_noturno', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.TransicaoDaJornadaNoturnoParaDiurno},
                      {value: 'hora_inicio_jornada_diurno', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.HorarioDeInicioDaJornadaDiurno},
                      {value: 'hora_inicio_jornada_noturno', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.HorarioDeInicioDaJornadaNoturno},
                      {value: 'trabalho_noturno', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.TrabalhoNoturno},
                      {value: 'duracao', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.DuracaoDaJornada},
                      {value: 'hora_extra', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.HoraExtra},
                      {value: 'transporte', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.Transporte},
                      {value: 'saude', label: 'Saúde'},
                      {value: 'fadiga_acumulada', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.FadigaAcumulada},
                      {value: 'problemas_pessoais', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.ProblemasPessoais},                    
                    ]}
                    required
                  />
                </div>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-4 col-md-offset-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.HistoricoDoSonoDosUltimos3Dias}?</label>
                </div>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.QueHorasDormiuNoUltimoDia}?</label>
                  <InputMask required value={this.state.ultimo_dia_dormiu} maskChar={null} name="ultimo_dia_dormiu" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'ultimo_dia_dormiu')} placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.QueHorasAcordouNoUltimoDia}?</label>
                  <InputMask required value={this.state.ultimo_dia_acordou} maskChar={null} name="ultimo_dia_acordou" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'ultimo_dia_acordou')} placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.QualidadeDoSonoNoUltimoDia}?</label>
                  <Select
                    className="form-field-name"
                    name="qualidade_sono_ultimo"
                    value={this.state.qualidade_sono_ultimo}
                    searchable={true}
                    placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarAplicabilidade}
                    onChange={this.handleSelectChange.bind(this, 'qualidade_sono_ultimo')}
                    options={[
                      {value: 'Ótimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Otimo},
                      {value: 'Bom', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Bom},
                      {value: 'Normal', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Normal},
                      {value: 'Ruim', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Ruim},
                      {value: 'Péssimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Pessimo},
                    ]}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.QueHorasDormiuNoPenultimoDia}?</label>
                  <InputMask required value={this.state.penultimo_dia_dormiu} maskChar={null} name="penultimo_dia_dormiu" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'penultimo_dia_dormiu')} placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.QueHorasAcordouNoPenultimoDia}?</label>
                  <InputMask required value={this.state.penultimo_dia_acordou} maskChar={null} name="penultimo_dia_acordou" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'penultimo_dia_acordou')} placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.QualidadeDoSonoNoPenultimoDia}?</label>
                  <Select
                    className="form-field-name"
                    name="qualidade_sono_penultimo"
                    value={this.state.qualidade_sono_penultimo}
                    searchable={true}
                    placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarAplicabilidade}
                    onChange={this.handleSelectChange.bind(this, 'qualidade_sono_penultimo')}
                    options={[
                      {value: 'Ótimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Otimo},
                      {value: 'Bom', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Bom},
                      {value: 'Normal', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Normal},
                      {value: 'Ruim', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Ruim},
                      {value: 'Péssimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Pessimo},
                   ]}
                   required
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.QueHorasDormiuHa3Dias}?</label>
                  <InputMask required value={this.state.tres_dias_horas_dormiu} maskChar={null} name="tres_dias_horas_dormiu" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'tres_dias_horas_dormiu')} placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.QueHorasAcordouHa3Dias}?</label>
                  <InputMask required value={this.state.tres_dias_horas_acordou} maskChar={null} name="tres_dias_horas_acordou" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'tres_dias_horas_acordou')} placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.QualidadeDoSonoHa3Dias}?</label>
                  <Select
                    className="form-field-name"
                    name="qualidade_sono_tres_dias"
                    value={this.state.qualidade_sono_tres_dias}
                    searchable={true}
                    placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarAplicabilidade}
                    onChange={this.handleSelectChange.bind(this, 'qualidade_sono_tres_dias')}
                    options={[
                      {value: 'Ótimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Otimo},
                      {value: 'Bom', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Bom},
                      {value: 'Normal', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Normal},
                      {value: 'Ruim', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Ruim},
                      {value: 'Péssimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Pessimo},
                    ]}
                    required
                  />
                </div>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.SinaisFisiologicosECognitivos}</label>
                  <Select
                    className="form-field-name"
                    name="sinais"
                    value={this.state.sinais}
                    searchable={true}
                    placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarUmaOpcao}
                    onChange={this.handleSelectChangeMulti.bind(this, 'sinais')}
                    multi={true}
                    options={[
                      {value: 'nao_fadigado', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.NaoMeSentiFadigado},
                      {value: 'nenhum_sinal_fisico', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.NenhumSinalFisicoPercebido},
                      {value: 'esfregar_olhos', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.EsfregarOsOlhosComFrequencia},
                      {value: 'piscadas_frequentes', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.PiscadasFrequentes},
                      {value: 'bocejar', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.Bocejo},
                      {value: 'olhar_fixo', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.OlharFixo},
                      {value: 'dificuldade_olhos_abertos', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.DificuldadeEmManterOsOlhosAbertos},
                      {value: 'dificuldade_olhos_abertos', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.DificuldadeEmManterOsOlhosAbertos},
                      {value: 'piscadas_longas', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.PiscadasLongas},
                      {value: 'cabeca_caindo', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.CabeçaBalancandoOuCaindo},
                      {value: 'inquietacao', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.Inquietacao},
                    ]}
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.Contramedidas}</label>
                  <Select
                    className="form-field-name"
                    name="contramedidas"
                    value={this.state.contramedidas}
                    searchable={true}
                    placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarUmaOpcao}
                    onChange={this.handleSelectChangeMulti.bind(this, 'contramedidas')}
                    multi={true}
                    options={[
                      {value: 'nao_fadigado', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.NaoMeSentiFadigado},
                      {value: 'alertou_colega', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.AlertouAoColegaSobreORiscoDeFadiga},
                      {value: 'aumentou_comunicacao', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.AumentouAComunicacao},
                      {value: 'comida_bebida', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.ComidaOuBebida},
                      {value: 'soneca', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.Soneca},
                      {value: 'coordenou_carga_trabalho', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.CoordenouACargaDeTrabalho},
                      {value: 'cafe', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.Cafeina},
                    ]}
                    required
                  />
                </div>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-4 col-md-offset-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.DetalhamentoECausasProvaveis}</label>
                  <textarea required style={{ height: 200 }} type="text" name="details" className="form-control" value={this.state.details} placeholder={this.locale.Usuarios.Questionario.formulario.placeholder.CasoNaoTenhaSeSentidoFadigadoPreenchaComNA} onChange={this.handleChange.bind(this, 'details')} />
                </div>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-4 col-md-offset-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.VoceAcreditaQueOSistemaDeGerenciamentoDeFadigaEEficiente}?</label>
                  <br/>
                  <Toggle
                    checked={this.state.fatigue_system_efficient}
                    aria-label='No label tag'
                    name="fatigue_system_efficient"
                    onChange={this.handleToggleChange.bind(this, 'fatigue_system_efficient')} />
                </div>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-4 col-md-offset-4">
                <div className="form-group">
                  <label>{this.locale.Usuarios.Questionario.formulario.Sugestoes}</label>
                  <textarea style={{ height: 200 }} type="text" name="sugestoes" className="form-control" value={this.state.sugestoes} onChange={this.handleChange.bind(this, 'sugestoes')} />
                </div>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-12">
                <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Usuarios.Questionario.formulario.botaoResponder}</button>
              </div>
            </div>
          </form>
        }
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default EmailFatigueQuestions;


// WEBPACK FOOTER //
// ./src/Components/Users/EmailFatigueQuestions.js